import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Select from "react-select";
import { FaFilePdf } from "react-icons/fa";
import html2pdf from "html2pdf.js";
import { BASE_URL } from './Constants'; 


const GetPdfAll = () => {

    const [departments, setDepartments] = useState([]);
    const [selectedDept, setSelectedDept] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(false);

    const [reportData, setReportData] = useState(null);
const [downloadingEmp, setDownloadingEmp] = useState(null);

    const [employees, setEmployees] = useState([]);
    const [loadingEmp, setLoadingEmp] = useState(false);

    const [showEmployees, setShowEmployees] = useState(false);
   
const filteredEmployees = employees.filter(emp =>
  emp.label.toLowerCase().includes(searchTerm.toLowerCase())
);
    /* ================= FETCH DEPARTMENTS ================= */
    useEffect(() => {
        fetchDepartments();
    }, []);

    const fetchDepartments = async () => {
        try {
            setLoading(true);

            const res = await fetch(`${BASE_URL}/dept`
            );

            const result = await res.json();

            if (result?.departments) {
                const options = result.departments.map(d => ({
                    value: d.dept_name,
                    label: d.dept_name
                }));

                setDepartments(options);
            } else {
                setDepartments([]);
            }

        } catch (error) {
            console.error("Dept fetch error:", error);
        }

        setLoading(false);
    };

    /* ================= FETCH EMPLOYEES ================= */
    const fetchEmployees = async (deptName) => {
        try {
            setLoadingEmp(true);

            const res = await fetch(
                `${BASE_URL}/get_employee_by_dept`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        dept: deptName
                    })
                }
            );

            const result = await res.json();

            if (result?.status && result?.data) {

                const options = result.data.map(emp => ({
                    value: emp.emp_code,
                    label: `${emp.emp_code} - ${emp.comp_name}`
                }));

                setEmployees(options);
            } else {
                setEmployees([]);
            }

        } catch (error) {
            console.error("Employee fetch error:", error);
            setEmployees([]);
        }

        setLoadingEmp(false);
    };

    const downloadSingleEmployee = async (empCode) => {
    try {
        setDownloadingEmp(empCode);

        const response = await fetch(
            `https://pms.vdcapp.in/backend/pms_employee_report/${empCode}`
        );

        const result = await response.json();

        if (!result?.status || !result?.data?.employee_details) {
            alert("No record found");
            setDownloadingEmp(null);
            return;
        }

        setReportData({
            employee: result.data.employee_details,
            written: result.data.current_year_written_questions || [],
            viva: result.data.current_year_viva_questions || []
        });

        // wait for DOM render
        setTimeout(() => {
            generatePDF(empCode);
        }, 500);

    } catch (error) {
        console.error(error);
        setDownloadingEmp(null);
    }
};

const generatePDF = (empCode) => {

    const element = document.getElementById("pdf-content");

    const opt = {
        margin: 0.3,
        filename: `PMS_Report_${empCode}.pdf`,
        html2canvas: { scale: 2 },
        jsPDF: {
            unit: "in",
            format: "a4",
            orientation: "landscape"
        },
    };

    html2pdf()
        .set(opt)
        .from(element)
        .save()
        .then(() => {
          
            setReportData(null);
            setDownloadingEmp(null);
        });
};

    /* ================= SUBMIT DEPARTMENT ================= */
    const handleSubmit = async () => {

        if (!selectedDept) {
            alert("Please select department");
            return;
        }

        await fetchEmployees(selectedDept.value);
        setShowEmployees(true);
      
    };

    /* ================= CHECKBOX HANDLERS ================= */

    

    /* ================= DOWNLOAD ================= */
    /* ================= DOWNLOAD ================= */

    const vivaCreatedBy = reportData?.viva?.[0]?.created_by || "-";
const vivaCreatedByName = reportData?.viva?.[0]?.created_by_name || "-";


    return (
        <div className="container-scroller">
            <Navbar />

            <div className="container-fluid page-body-wrapper">
                <Sidebar />

                <div className="main-panel">
                    <div className="content-wrapper">

                        <h3 style={{ marginBottom: "20px" }}>
                            PMS Report
                        </h3>

                        {/* ================= DEPARTMENT CARD ================= */}
                        <div className="card">
                            <div className="card-body">

                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "15px",
                                        flexWrap: "wrap"
                                    }}
                                >
                                    {/* Department Select */}
                                    <div style={{ minWidth: "300px", flex: 1 }}>
                                        <label style={{ fontWeight: "600" }}>
                                            Department
                                        </label>

                                        <Select
                                            options={departments}
                                            value={selectedDept}
                                            onChange={setSelectedDept}
                                            placeholder="Search Department..."
                                            isLoading={loading}
                                            isClearable
                                        />
                                    </div>

                                    {/* Submit Button */}
                                    <div style={{ alignSelf: "end" }}>
                                        <button
                                            className="btn btn-primary"
                                            onClick={handleSubmit}
                                            style={{ marginTop: "22px" }}
                                        >
                                            Submit
                                        </button>
                                    </div>

                                </div>

                            </div>
                        </div>

                        {/* ================= EMPLOYEE LIST ================= */}
                        {showEmployees && (
  <div className="card mt-3">
    <div className="card-body">

      <h5>Select Employee</h5>

      {/* SEARCH BOX */}
      <div style={{ marginBottom: "10px" }}>
        <input
          type="text"
          className="form-control"
          placeholder="Search by Emp ID or Name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {/* Employee List */}
      <div
        style={{
          maxHeight: "300px",
          overflowY: "auto",
          border: "1px solid #eee",
          padding: "10px",
          borderRadius: "6px"
        }}
      >
        {loadingEmp ? (
          <p>Loading employees...</p>
        ) : filteredEmployees.length === 0 ? (
          <p>No employees found</p>
        ) : (
          filteredEmployees.map(emp => (
            <div
              key={emp.value}
              style={{
                padding: "8px 6px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #f2f2f2"
              }}
            >
              <span>{emp.label}</span>

              <FaFilePdf
                style={{
                  color: "#dc3545",
                  cursor: "pointer",
                  fontSize: "20px"
                }}
                title="Download PDF"
                onClick={() => downloadSingleEmployee(emp.value)}
              />
            </div>
          ))
        )}
      </div>

    </div>
  </div>
)}

                    </div>
                </div>
                {/* ================= HIDDEN FULL PDF CONTENT ================= */}
{/* ================= HIDDEN FULL PDF CONTENT ================= */}
{reportData?.employee && (
  <div style={{ position: "absolute", left: "-9999px", top: 0 }}>
    <div id="pdf-content" className="card p-4">

      <h3 className="text-center mb-4">
        PMS Employee Report
      </h3>

      {/* EMPLOYEE DETAILS */}
      <table
        className="table table-bordered"
        style={{
          tableLayout: "fixed",
          width: "100%",
          borderCollapse: "collapse"
        }}
      >
        <tbody>

          <tr>
            <td style={{ width: "15%" }}><b>Emp ID</b></td>
            <td style={{ width: "35%" }}>
              {reportData?.employee?.emp_code || "-"}
            </td>
            <td style={{ width: "15%" }}><b>Name</b></td>
            <td style={{ width: "35%" }}>
              {reportData?.employee?.comp_name || "-"}
            </td>
          </tr>

          <tr>
            <td><b>Branch</b></td>
            <td>{reportData?.employee?.location_name || "-"}</td>
            <td><b>Reporting Manager</b></td>
            <td>
              {reportData?.employee?.report_manager_name || "-"}
              ({reportData?.employee?.report_mngr || "-"})
            </td>
          </tr>

          {/* DOJ SECTION */}
          <tr>
            <td ><b>DOJ</b></td>
            <td >
              {reportData?.employee?.doj
                ? reportData.employee.doj.split("-").reverse().join("/")
                : "-"}
            </td>
            <td><b>Experience</b></td>
            <td>
              {reportData?.employee?.experience_years ?? "-"} Years
            </td>
          </tr>

          <tr>
  <td><b>Department</b></td>
  <td>{reportData?.employee?.dept_name || "-"}</td>
  <td><b>Viva Done By</b></td>
  <td>
    {vivaCreatedBy !== "-"
      ? `${vivaCreatedBy} (${vivaCreatedByName})`
      : "-"}
  </td>
</tr>

        </tbody>
      </table>

      {/* MARKS */}
      <h5 className="mt-4">Marks Details</h5>

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Type</th>
            <th>Total</th>
            <th>Scored</th>
          </tr>
        </thead>
        <tbody>

          {/* CURRENT YEAR */}
          <tr style={{ background: "#f5f5f5", fontWeight: "bold" }}>
            <td colSpan="3">Current Year</td>
          </tr>

          <tr>
            <td>Written Exam</td>
            <td>
              {reportData?.employee?.total_current_year_written_questions ?? 0}
            </td>
            <td>
              {reportData?.employee?.total_current_year_written_scored ?? 0}
            </td>
          </tr>

          <tr>
            <td>Viva</td>
            <td>
              {reportData?.employee?.total_current_year_viva_questions ?? 0}
            </td>
            <td>
              {reportData?.employee?.total_current_year_viva_scored ?? 0}
            </td>
          </tr>

          {/* PREVIOUS YEAR */}
          <tr style={{ background: "#f5f5f5", fontWeight: "bold" }}>
            <td colSpan="3">Previous Year</td>
          </tr>

          <tr>
            <td>Written Exam</td>
            <td>
              {reportData?.employee?.total_previous_year_written_questions ?? 0}
            </td>
            <td>
              {reportData?.employee?.total_previous_year_written_scored ?? 0}
            </td>
          </tr>

          <tr>
            <td>Viva</td>
            <td>
              {(reportData?.employee?.total_previous_year_viva_questions || 0) * 5}
            </td>
            <td>
              {reportData?.employee?.total_previous_year_viva_scored ?? 0}
            </td>
          </tr>

        </tbody>
      </table>

      {/* FEEDBACK */}
      <h5 className="mt-4">Feedback Details</h5>

      <table className="table table-bordered">
        <tbody>
          <tr>
            <td><b>Overall Remarks</b></td>
            <td style={{
              width: "40%",
              whiteSpace: "normal",
              wordBreak: "break-word",
              overflowWrap: "anywhere",
              verticalAlign: "top"
            }}>
              {reportData?.employee?.overall_remarks || "-"}
            </td>
            <td><b>Feedback Remarks</b></td>
            <td>{reportData?.employee?.feedback_marks || "-"}</td>
          </tr>

          <tr>
            <td><b>Interview Feedback</b></td>
            <td>{reportData?.employee?.interviewer_feed_back || "-"}</td>
            <td><b>Training Needs</b></td>
            <td>{reportData?.employee?.training_needs || "-"}</td>
          </tr>
        </tbody>
      </table>

      {/* WRITTEN QUESTIONS */}
      <h5 className="mt-4">Adrenalin Questions</h5>

      <table
  className="table table-bordered"
  style={{ tableLayout: "fixed", width: "100%" }}
>
  <tbody>
    {reportData?.written?.map((q, i) => (
      <tr key={i}>
        <td style={{ width: "5%", verticalAlign: "top" }}>
          {i + 1}
        </td>

        <td
          style={{
            width: "45%",
            verticalAlign: "top",
            whiteSpace: "normal",
            wordBreak: "break-word",
            overflowWrap: "anywhere"
          }}
        >
          {q?.question}
        </td>

        <td
          style={{
            width: "35%",
            verticalAlign: "top",
            whiteSpace: "normal",
            wordBreak: "break-word",
            overflowWrap: "anywhere"
          }}
        >
          {q?.emp_answer}
        </td>

        <td
          style={{
            width: "15%",
            verticalAlign: "top"
          }}
        >
          {q?.score}
        </td>
      </tr>
    ))}
  </tbody>
</table>

      <div style={{ pageBreakBefore: "always" }}></div>

      {/* VIVA QUESTIONS */}
      <h5 className="mt-4">Viva Questions</h5>

      <table
  className="table table-bordered"
  style={{ tableLayout: "fixed", width: "100%" }}
>
  <tbody>
    {reportData?.viva?.map((v, i) => (
      <tr key={i}>
        <td style={{ width: "5%", verticalAlign: "top" }}>
          {i + 1}
        </td>

        <td
          style={{
            width: "35%",
            verticalAlign: "top",
            whiteSpace: "normal",
            wordBreak: "break-word",
            overflowWrap: "anywhere"
          }}
        >
          {v?.question}
        </td>

        <td
          style={{
            width: "25%",
            verticalAlign: "top",
            whiteSpace: "normal",
            wordBreak: "break-word",
            overflowWrap: "anywhere"
          }}
        >
          {v?.answer}
        </td>

        <td
          style={{
            width: "15%",
            verticalAlign: "top",
            whiteSpace: "normal",
            wordBreak: "break-word",
            overflowWrap: "anywhere"
          }}
        >
          {v?.answered_radio}
        </td>

        <td
          style={{
            width: "20%",
            verticalAlign: "top",
            whiteSpace: "normal",
            wordBreak: "break-word",
            overflowWrap: "anywhere"
          }}
        >
          {v?.remarks}
        </td>
      </tr>
    ))}
  </tbody>
</table>

    </div>
  </div>
)}
            </div>
        </div>
    );
};

export default GetPdfAll;